module.exports = __webpack_public_path__ + "static/healthnx-mission-two-8fa0e26ef4c44af67645528701df9d69.jpg";